(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nini-rd-cafe-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nini-rd-slider')) {
    class NiniRdSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rd-track]');
        this.prev = this.querySelector('[data-rd-prev]');
        this.next = this.querySelector('[data-rd-next]');
        if (!this.track) return;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        });

        const start = parseInt(this.dataset.start || '0', 10);
        if (start > 0) {
          const jump = () => {
            if (!this.touched) this.goTo(start, 'instant');
          };
          ['pointerdown', 'wheel', 'keydown'].forEach((type) =>
            this.track.addEventListener(type, () => (this.touched = true), { passive: true, once: true })
          );
          this.prev?.addEventListener('click', () => (this.touched = true));
          this.next?.addEventListener('click', () => (this.touched = true));
          requestAnimationFrame(jump);
          if (document.readyState !== 'complete') window.addEventListener('load', jump, { once: true });
        }

        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest?.('[data-rd-slide]');
          if (slide && this.track.contains(slide)) this.goTo(this.slides().indexOf(slide), 'smooth');
        });

        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
      }

      slides() {
        return [...this.track.querySelectorAll('[data-rd-slide]')];
      }

      isCentered() {
        return getComputedStyle(this.slides()[0] || this.track).scrollSnapAlign.includes('center');
      }

      offsetFor(slide) {
        const left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        if (this.isCentered()) {
          return left - (this.track.clientWidth - slide.offsetWidth) / 2;
        }
        return left;
      }

      currentIndex() {
        const slides = this.slides();
        let best = 0;
        let bestDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(this.offsetFor(slide) - this.track.scrollLeft);
          if (distance < bestDistance) { bestDistance = distance; best = index; }
        });
        return best;
      }

      goTo(index, behavior) {
        const slides = this.slides();
        const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!slide) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.offsetFor(slide), behavior: reduce ? 'instant' : behavior || 'smooth' });
      }

      step(direction) {
        this.goTo(this.currentIndex() + direction, 'smooth');
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }
    customElements.define('nini-rd-slider', NiniRdSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
